import styled, { css } from 'styled-components'

export const StyledGrid = styled.div<{ $extraMargin?: boolean }>`
  ${({ theme, $extraMargin }) => css`
    --column-gap: 38px;
    --columns: 2;

    ${theme.media.up.md} {
      display: flex;
      flex-wrap: wrap;
      align-items: baseline;
      row-gap: 45px;
      column-gap: var(--column-gap);
      margin-bottom: ${$extraMargin ? '45px' : ''};
    }

    > * {
      ${theme.media.up.md} {
        flex-basis: calc(
          100% / var(--columns) -
            ((var(--column-gap) * calc(var(--columns) - 1)) / var(--columns))
        );
      }

      ${theme.media.up.lg} {
        --columns: 3;
      }

      ${theme.media.up.xl} {
        --columns: 4;
      }
    }

    &:target {
      scroll-margin-top: 200px;
    }
  `}
`
